export var ZONES = ["A", "B", "C", "D", "E", "F"];

/** Display labels for volume sweep zones (e.g. "Right Lateral" for zone A) */
export var VOLUME_SWEEP_ZONE_LABELS = {
  A: "Right Lateral",
  B: "Left Lateral",
  C: "Right Anterior",
  D: "Left Anterior",
  E: "Right Posterior",
  F: "Left Posterior"
};
export var INITIAL_ZONE_PROGRESS = ZONES.map(function (zone) {
  return {
    zone: zone,
    transverse: false,
    longitudinal: false
  };
});
export var INITIAL_POINT_PROGRESS = Array.from({
  length: 14
}, function (_, i) {
  return {
    point: i + 1,
    transverse: false,
    longitudinal: false
  };
});